export const iconList = [
  '',
  'calculator',
  'appraisal',
  'bell2',
  'truck',
  'triangle2',
  'eye',
  'bubbles',
  'mobile',
  'bubble-dots',
  'play_circle_outline',
  'envelop3',
  'calendar4',
  'location5',
  'clock',
  'bubble2',
  'new-tab',
  'spinner8',
  'info',
  'heart3',
  'user3',
  'google',
  'done',
  '5star',
  'heart4',
  'arrow-right2',
  'keyless-entrystart',
  'edit2',
  'price-tags2',
  'phone2',
  'open_in_new',
  'question3',
  'plus3',
  'minus3',
  'plus-circle2',
  'multi-zone-climate-control',
  'trip-computer',
  'navigation',
  'leather-seats',
  'bluetooth',
  'sunroofmoonroof',
  'adaptive-cruise-control',
  'awd4wd',
  'heads-up-display',
  'parking-sensors',
  'heated-seats',
  'back-up-camera',
  'fuel-economy',
  'lane-departure-warning',
  'automatic-emergency-braking',
  '360-degree-camera',
  'upgraded-stereo',
  'cooled-seats',
  'upgraded-headlights',
  'low-miles',
  'spare-tire-included',
  'apple-carplay',
  'apple-carplayandroid-auto',
  'auto-climate-control',
  'power-driver-seat',
  'power-liftgatetrunk',
  'rear-bench-seats',
  'stability-control',
  'third-row-seating',
  'upgraded-engine',
  'usb-inputs',
  'blind-spot-monitoring',
  'tire-pressure-warning',
  'alarm',
  'aux-audio-inputs',
  'edmunds-car',
  'circle-half',
  'cross2',
  'cross3',
  'menu7',
  'checkbox-checked2',
  'checkbox-unchecked2',
  'checkmark-circle',
  'circle2',
  'facebook2',
  'twitter',
  'play',
  'instagram',
  'rss',
  'linkedin',
  'pinterest',
  'sentiment_dissatisfied',
  'sentiment_neutral',
  'sentiment_satisfied',
  'search',
  'search2',
  'star-empty',
  'star-empty2',
  'star-full',
  'cancel-circle2',
  'checkmark',
  'arrow-up2',
  'arrow-down2',
  'arrow-right3',
  'arrow-left3',
  'arrow-up3',
  'arrow-down3',
  'arrow-left4',
  'arrow-right4',
  'arrow-down4',
  'arrow-up4',
  'arrow-up5',
  'arrow-down5',
  'arrow-right8',
  'share3',
  'arrow-up8',
  'arrow-down8',
  'pulse2',
  'price-tag',
  'location',
  'stack',
  'bell3',
  'bubbles5',
  'key2',
  'steering-wheel',
  'shield-check',
  'thumbs-up2',
  'fire',
  'notification2',
  'stats-decline',
  'camera',
  'camera2',
  'grid6',
  'transit',
  'download4',
  'warning2',
  'car',
  'clipboard2',
  'clipboard5',
  'cash3',
  'money10',
  'history',
  'audio_steering_wheel_control',
  'fold_flat_rear_seats',
  'post_collision_safety',
  'pre-collision',
  'remote_start',
  'mobile_internet',
  'towing_hitch',
  'electronic_folding_mirrors',
  'towing_capacity',
  'rear_entertainment_system',
  'soft_top',
  'hard_top',
  'bed',
  'extended_cab',
  'crew_cab',
  'standard_cab',
  'home5',
  'user',
  'users',
  'users4',
  'user-tie',
  'car2',
  'gas',
  'hybrid_mpg',
  'battery_charging_full2',
  'bucket',
  'pencil',
  'images',
  'link',
  'certificate1',
  'compare_cars',
];
